import { render, staticRenderFns } from "./MST_AREA.vue?vue&type=template&id=1d0ab604&scoped=true"
import script from "./MST_AREA.vue?vue&type=script&lang=ts"
export * from "./MST_AREA.vue?vue&type=script&lang=ts"
import style0 from "./MST_AREA.vue?vue&type=style&index=0&id=1d0ab604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0ab604",
  null
  
)

export default component.exports